import UploadQrcode from './src/main'

export default UploadQrcode



// WEBPACK FOOTER //
// ./src/views/question-review/components/UploadQrcode/index.js